import OaApiService from "./OaApiService";

export default class CaseService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.getByIdUrl = "/CaseREST/id/";
    this.updateUrl = "/CaseREST/update-case/";
  }

  getCaseTypes() {
    return this.get("/CaseREST/types");
  }

  getCaseDetails(caseId) {
    return this.get(this.getByIdUrl + caseId);
  }

  updateCaseDetails(data) {
    return this.post(this.updateUrl + data.caseId, data);
  }

  createNote(data) {
    return this.post("/NoteREST/create-note", data);
  }
}
